import { createSelector } from 'reselect';
import { userSelector } from '@lingoda/auth';
import studentsSelector from './studentsSelector';

export default createSelector(userSelector, studentsSelector, (user, students) =>
    user ? students.find((student) => student.id === user.studentId) : undefined,
);
